
function trestonDebug(message) {
	//console.log(message);
}

function removeFamilyProductsFilter(familyId, filter){
	var tableHXpath = document.getElementById("family-" + familyId + "-products-table").getAttribute("hx-get");
	if(tableHXpath.indexOf(document.location.host) == -1) {
		tableHXpath = "https://" + document.location.host + tableHXpath;
	}
	var tableUrl = new URL(tableHXpath);
	var tableParams = tableUrl.searchParams;
	if(tableParams.has("filters")) {
		var filters = JSON.parse(tableParams.get("filters"));
		delete filters[filter];
		tableParams.set("filters", JSON.stringify(filters));
	}
	var selectedFilters = "";
	var filters = JSON.parse(tableParams.get("filters"));
	for(key in filters ) {
		var encodedValue = filters[key].replaceAll(' ', '-');
		if(document.querySelector("#f" + familyId + '-' + key + '-' + encodedValue) !== null) {
			var humanValue = document.querySelector("#f" + familyId + '-' + key + '-' + encodedValue).dataset.filtervalue || filters[key];
		}
		else {
			var humanValue = filters[key];
		}
		selectedFilters += '<button data-filter="' + key + '" onclick="removeFamilyProductsFilter(\'' + familyId + '\', \'' + key + '\')">' + humanValue + '</button>';
	}

	document.querySelector("#views-view-" + familyId + " .selected-options").innerHTML = selectedFilters;
	document.getElementById("family-" + familyId + "-products-table").setAttribute("hx-get", tableUrl.href);
	htmx.process(document.getElementById("family-" + familyId + "-products-table"));
    htmx.trigger("#family-" + familyId + "-products-table", "optionsChanged");
}

function refreshFamilyProductsTable(familyId, filter, value) {
	var tableHXpath = document.getElementById("family-" + familyId + "-products-table").getAttribute("hx-get");
	var filterName = filter;
	if(tableHXpath.indexOf(document.location.host) == -1) {
		tableHXpath = "https://" + document.location.host + tableHXpath;
	}
	var tableUrl = new URL(tableHXpath);
	var tableParams = tableUrl.searchParams;

	if(tableParams.has("filters")) {
		var filters = JSON.parse(tableParams.get("filters"));
		filters[filterName] = value;
		tableParams.set("filters", JSON.stringify(filters));
	}
	else {
		var filters = {};
		filters[filterName] = value;
		tableParams.set("filters", JSON.stringify(filters));
	}

	var selectedFilters = "";
	var filters = JSON.parse(tableParams.get("filters"));
	for(key in filters ) {
		var encodedValue = filters[key].replaceAll(' ', '-');
		if(document.querySelector("#f" + familyId + '-' + key + '-' + encodedValue) !== null) {
			var humanValue = document.querySelector("#f" + familyId + '-' + key + '-' + encodedValue).dataset.filtervalue || filters[key];			
		}
		else {
			var humanValue = filters[key];
		}
		selectedFilters += '<button data-filter="' + key + '" onclick="removeFamilyProductsFilter(\'' + familyId + '\', \'' + key + '\')">' + humanValue + '</button>';
	}

	document.querySelector("#views-view-" + familyId + " .selected-options").innerHTML = selectedFilters;
	document.getElementById("family-" + familyId + "-products-table").setAttribute("hx-get", tableUrl.href);
	htmx.process(document.getElementById("family-" + familyId + "-products-table"));
    htmx.trigger("#family-" + familyId + "-products-table", "optionsChanged");
}

function activateAvailabilityTooltips() {
	jQuery(".block-family-product-listing .tooltip-opener-icon:not('.active'), #block-treston-accessoriesfamilyselect .tooltip-opener-icon:not('.active'), .esd-products .tooltip-opener-icon:not('.active')").each(function(){
		  var elem = jQuery(this);
			elem.on("click", function(e){
			var windowWidth = jQuery(window).width();
			var opener = jQuery(e.target);
			var position = opener.offset();
			var left = position.left < 170 ? 20 - position.left : -170;
			if(position.left > windowWidth - 170) {
				left = windowWidth - 360 - position.left;
			}
			var tooltip = opener.parent().find(".tooltip-inner");
			var tooltipTop = tooltip.find(".tooltip-top");
			tooltipTop.css("left", (0 - left) + "px");

			var closer = tooltip.find('.tooltip-closer');
			closer.on("click", function(){
				tooltip.removeClass("open");
			});
			tooltip.css('top', 32 + 'px');

			tooltip.css('left', left + 'px');
			tooltip.toggleClass("open");
		});
		elem.addClass('active');
	});
}


var Treston = Treston || {};
Treston.productsListing = {
	enableCartForms: function(blockElementSelector){
		var elementQuery = blockElementSelector + ' .add-quantity:not(.appl), ' + blockElementSelector + ' .decrease-quantity:not(.appl)';
		trestonDebug("Elements to modify: " + jQuery(elementQuery).length);
		jQuery(elementQuery).each(function( x, button ){
			var buttonControl = jQuery(button); 
			buttonControl.addClass('appl');
			buttonControl.off('click').on('click',function(e){
			  var input = jQuery(this).parent().find('.quantity')[0];
			  if( this.className.indexOf('add-quantity') != -1 ){
				input.value++;
			  }else{
				input.value--;
			  }
			  input.value = input.value<1?1:(input.value>99?99:input.value);
			});
		});
	},
	enableFilters: function(blockElementSelector){
		jQuery(blockElementSelector + " .all-options .filter:not(.appl)").each(function(index, element) {
			var filter = jQuery(element);
			filter.on("click", function(){
				filter.siblings().removeClass("open");
				filter.toggleClass("open");
			});
			filter.addClass("appl");
		});
	},
	enableMobileRow: function(blockElementSelector) {
		jQuery(blockElementSelector + " TABLE.product-listing-table .cell-opener:not(.appl)").each(function(index, element){
			var opener = jQuery(element);
			opener.unbind('click');
			opener.on('click', function(){
				var row = opener.parent().parent();
				var tbody = row.parent();
				if(row.hasClass("open")) {
					tbody.find("TR.open").removeClass("open");
				}
				else {
					tbody.find("TR.open").removeClass("open");
					row.addClass('open');
				}
			});
			opener.addClass("appl");
		});
	}
};


jQuery(".block-family-product-listing").on("htmx:afterSwap", function(e){
	Treston.productsListing.enableCartForms(".block-family-product-listing");
	trestonDebug(jQuery('.block-family-product-listing .commerce-ajax-submit:not(.appl)').length +  " ajaxsubmits in product family listings.");

  	once('ajax', '.block-family-product-listing .commerce-ajax-submit').forEach(function(el) {
        var elementSettings = {};

        // Ajax submits specified in this manner automatically submit to the
        // normal form action.
        elementSettings.url = jQuery(el.form).attr('action');
        // Form submit button clicks need to tell the form what was clicked so
        // it gets passed in the POST request.
        elementSettings.setClick = true;
        // Form buttons use the 'click' event rather than mousedown.
        elementSettings.event = 'click';
        // Clicked form buttons look better with the throbber than the progress
        // bar.
        elementSettings.progress = { type: 'throbber' };
        elementSettings.base = el.id;
        elementSettings.element = el;

        Drupal.ajax(elementSettings);
		jQuery(el).addClass("appl");
  	});


	jQuery(".block-family-product-listing .downloads-list-container:not(.appl), .block-treston-product-listings .downloads-list-container:not(.appl)").each(function(){
		jQuery(this).on("click", function(e){
			var link = jQuery(e.target);
			link.closest("tbody").find(".downloads-list-container.open").each(function(e) {
				if(this !== link[0] ) {
					jQuery(this).removeClass("open").find("ul").slideToggle();
				}					
			}), link.toggleClass("open").find("ul").slideToggle();
		});
		jQuery(this).addClass("appl");
	});

});


jQuery("#accessories-table-container").on("htmx:afterSwap", function(e){
	Treston.productsListing.enableCartForms("#accessories-table-container");
	trestonDebug(jQuery('#accessories-table-container .commerce-ajax-submit:not(.appl)').length +  " ajaxsubmits in accessory family listings.");
	activateAvailabilityTooltips();
	once('ajax', '#accessories-table-container .commerce-ajax-submit').forEach(function(el) {
        var elementSettings = {};

        // Ajax submits specified in this manner automatically submit to the
        // normal form action.
        elementSettings.url = jQuery(el.form).attr('action');
        // Form submit button clicks need to tell the form what was clicked so
        // it gets passed in the POST request.
        elementSettings.setClick = true;
        // Form buttons use the 'click' event rather than mousedown.
        elementSettings.event = 'click';
        // Clicked form buttons look better with the throbber than the progress
        // bar.
        elementSettings.progress = { type: 'throbber' };
        elementSettings.base = el.id;
        elementSettings.element = el;

        Drupal.ajax(elementSettings);
		jQuery(el).addClass("appl");
	});


	jQuery("#accessories-table-container .downloads-list-container:not(.appl), .block-treston-product-listings .downloads-list-container:not(.appl)").each(function(){
		jQuery(this).on("click", function(e){
			var link = jQuery(e.target);
			link.closest("tbody").find(".downloads-list-container.open").each(function(e) {
				if(this !== link[0] ) {
					jQuery(this).removeClass("open").find("ul").slideToggle();
				}					
			}), link.toggleClass("open").find("ul").slideToggle();
		});
		jQuery(this).addClass("appl");
	});
});

jQuery("#products-listing-familyapplication").on("htmx:afterSwap", function(e){
	Treston.productsListing.enableCartForms("#products-listing-familyapplication");
	trestonDebug(jQuery('#products-listing-familyapplication .commerce-ajax-submit:not(.appl)').length +  " ajaxsubmits in accessory family listings.");
	activateAvailabilityTooltips();
	once('ajax', '#products-listing-familyapplication .commerce-ajax-submit').forEach(function(el) {
        var elementSettings = {};

        // Ajax submits specified in this manner automatically submit to the
        // normal form action.
        elementSettings.url = jQuery(el.form).attr('action');
        // Form submit button clicks need to tell the form what was clicked so
        // it gets passed in the POST request.
        elementSettings.setClick = true;
        // Form buttons use the 'click' event rather than mousedown.
        elementSettings.event = 'click';
        // Clicked form buttons look better with the throbber than the progress
        // bar.
        elementSettings.progress = { type: 'throbber' };
        elementSettings.base = el.id;
        elementSettings.element = el;

        Drupal.ajax(elementSettings);
		jQuery(el).addClass("appl");
	});


	jQuery("#products-listing-familyapplication .downloads-list-container:not(.appl)").each(function(){
		jQuery(this).on("click", function(e){
			var link = jQuery(e.target);
			link.closest("tbody").find(".downloads-list-container.open").each(function(e) {
				if(this !== link[0] ) {
					jQuery(this).removeClass("open").find("ul").slideToggle();
				}					
			}), link.toggleClass("open").find("ul").slideToggle();
		});
		jQuery(this).addClass("appl");
	});
});

if(jQuery(".product-listings-family-products.hx-unprocessed").length > 0) {
	trestonDebug(".product-listings-family-products.hx-unprocessed length is: " + jQuery(".product-listings-family-products.hx-unprocessed").length);
	var unprocessedElements = document.querySelectorAll(".product-listings-family-products.hx-unprocessed");
	unprocessedElements.forEach(function(element){
		//trestonDebug(element.attributes);
		htmx.process(element);
		element.classList.remove("hx-unprocessed");
	});
}


if(jQuery(".layout-content-bottom *[hx-get]").length > 0) {
	if(jQuery('#accessories-table-container.hx-unprocessed').length == 1) {
		htmx.process(document.getElementById('accessories-table-container'));
		jQuery("#accessories-table-container.hx-unprocessed").removeClass("hx-unprocessed");

	}
	if(jQuery('#family-list-buttons.hx-unprocessed').length == 1) {
		jQuery("#family-list-buttons.hx-unprocessed").removeClass("hx-unprocessed");
		htmx.process(document.getElementById('family-list-buttons'));


		jQuery('#family-list-buttons .cat-selection').on("click", function(e){
			jQuery("#family-list-buttons BUTTON.selected").removeClass("selected");

			var button = jQuery(e.target);
			var family = button.data("family-id");
			var query = location.search;
			var params = new URL(location.href).searchParams;
			var selectedFamily = null;
			if(params.length) {
				selectedFamily = params.get('accessories[0]');
			}
			if(selectedFamily !== null && selectedFamily.length > 12){
				selectedFamily = selectedFamily.substring(12);
			}
			history.pushState(family , "", location.pathname + "?accessories[0]=accessories:" + family + "#block-treston-accessoriesfamilyselect");
			button.addClass("selected");
			document.getElementById("block-treston-accessoriesfamilyselect").scrollIntoView();
		})
	}
}


jQuery(".block-family-product-listing").on("htmx:afterSwap", function(){
	Treston.productsListing.enableFilters(".block-family-product-listing");
	Treston.productsListing.enableMobileRow(".block-family-product-listing");
});
jQuery("#accessories-table-container").on("htmx:afterSwap", function(){
	Treston.productsListing.enableMobileRow("#accessories-table-container");
});
jQuery("#products-listing-familyapplication").on("htmx:afterSwap", function(){
	Treston.productsListing.enableMobileRow("#products-listing-familyapplication");
});



(function ($, Drupal, drupalSettings) {
  "use strict";
  activateAvailabilityTooltips();	
})(jQuery, Drupal, drupalSettings);

jQuery(".application-listing-family").each(function(){
	var family = jQuery(this);
	family.css('order', (family.index() * 2) + 2);
	family.attr('data-order', (family.index() * 2) + 2);
	family.on('click', function(){
		jQuery("#products-listing-familyapplication").html('<div class="ajax-region-loader with-margin"> </div>');
		var itemsPerRow = 8;
		var windowWidth = jQuery(window).width();
		if(windowWidth < 1024) {
			itemsPerRow = 4;
		}
		if(windowWidth < 640) {
			itemsPerRow = 2;
		}
		trestonDebug(itemsPerRow);
		var selectedFamily = jQuery(".application-listing-family.family-open");
		var selectedFamilyId = null;
		if(selectedFamily.length > 0) {
			selectedFamilyId = jQuery(selectedFamily[0]).attr("id");
		}
		jQuery(".application-listing-family.family-open").removeClass('family-open');
		if(family.attr("id") != selectedFamilyId) {
			family.addClass('family-open');
			jQuery("#products-listing-familyapplication").css("display", "block");
			jQuery("#products-listing-familyapplication").css("order", (Math.ceil(family.css("order")/itemsPerRow) * itemsPerRow) + 1);
			trestonDebug(jQuery("#products-listing-familyapplication").css("order"));
			htmx.trigger("#" + family.attr("id"), "familySelected");
		}
		else {
			jQuery("#products-listing-familyapplication").css("display", "none");
		}
	});
});